// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"191":"f2c01e2d","233":"9a61dac8"}[chunkId] + ".css";
};